import { render } from "./BuildIcon2.vue?vue&type=template&id=5ea5c96c&scoped=true"
import script from "./BuildIcon2.vue?vue&type=script&lang=js"
export * from "./BuildIcon2.vue?vue&type=script&lang=js"

import "./BuildIcon2.vue?vue&type=style&index=0&id=5ea5c96c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ea5c96c"]])

export default __exports__